// packages
import { useLayoutEffect, useState } from "react";
import "./gallery.css";
import Axios from "axios";
import studentInfo from "./studentInfo"

const importAll = (r) => {
  return r.keys().map(r);
};

function AccordionItem({ title, children, isOpen, onClick }) {
  return (
    <div className="bg-white rounded-xl shadow p-4 mb-4">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center font-semibold text-lg text-left"
      >
        {title}
        <svg
          className={`w-5 h-5 transition-transform ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && <div className="mt-4">{children}</div>}
    </div>
  );
}

function SubAccordionItem({
  title,
  parent,
  imageCount,
  content,
  isOpen,
  onClick,
}) {
  let Images = [];
  for (let x = 1; x <= imageCount; x++) {
    Images.push(
      "./event-gallery/" + parent + "/" + title + "/" + title + " (" + x + ").webp"
    );
  }

  return (
    <div className="bg-gray-100 rounded-lg p-3">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center font-medium text-left"
      >
        {title}
        <svg
          className={`w-4 h-4 transition-transform ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="accordianImages mt-3">
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Images.map((image, index) => (
              <li key={index} className="p-5 h-64 accordian-image-li relative">
                <img
                  src={image}
                  alt={image}
                  className="accordianImage object-cover w-full h-full rounded-lg"
                />
                <a className="accordian-image-download" href={image} download={image}>Download</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

// ==========================
// LOGIN PROTECTED GALLERY
// ==========================
const Gallery = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState({});
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isUserDataAvailable, userDataSet] = useState(false);
  const [UserDatas, setUserData] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  let UserData;

  function getUserData(e) {
    let userData;
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://eschool.appsosindia.org/views/api/std_tc_list.php?school_code=HGSF',
        headers: { 
          'Authorization': 'Vksmpy001AAsos',
        },
      };

      Axios.request(config)
      .then((response) => {
        userData = JSON.stringify(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    return userData;
  }

  function findStudent(data, name, tcNo) {
    const searchName = name.trim().toLowerCase();
    const searchTcNo = tcNo.trim();
    
    return data.student_tcinfo.find(
      (student) =>
        student.STD_NAME &&
        student.STD_NAME.trim().toLowerCase() === searchName &&
        student.STD_TCNO &&
        student.STD_TCNO.trim() === searchTcNo
    );
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    let UserData;
    if(!isUserDataAvailable) {
      // UserData = await getUserData();
      UserData = JSON.stringify(studentInfo);
      await setUserData(UserData)
      userDataSet(true)
    } else { 
      UserData = UserDatas
    }

    console.log(UserData)
    
    let sercheinfo = findStudent(JSON.parse(UserData), username, password);
    if(typeof sercheinfo != 'undefined') {
      setIsAuthenticated(true);
      setError("");
      
    } else {
      setError("Invalid student name or Tc"); 
    }
  };

  const toggleMain = (id) => {
    setOpenMain((prev) => (prev === id ? null : id));
    setOpenSub({});
  };

  const toggleSub = (mainId, subId) => {
    setOpenSub((prev) => ({
      ...prev,
      [mainId]: prev[mainId] === subId ? null : subId,
    }));
  };

  // ==========================
  // LOGIN SCREEN
  // ==========================
  if (!isAuthenticated) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <form
          onSubmit={handleLogin}
          className="bg-white p-8 rounded-xl shadow-md w-full max-w-sm"
        >
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Student full name</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Tc No</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2"
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            Login
          </button>
        </form>
      </div>
    );
  } else { 
    return (
    <div className="bg-gray-100 p-6">

      {/* {Object.entries(images).map(([path, module], idx) => (        
        <div key={idx} className="bg-white rounded shadow p-2">
          <img src={module.default} alt={`Image ${idx}`} className="w-full h-auto rounded" />
          <p className="text-sm mt-2 text-gray-600 truncate">{path.split('/').pop()}</p>
        </div>
      ))} */}

      <div className="max-w-1xl mx-auto space-y-4">
        {/* Main Accordion 1 */}
        <AccordionItem
          title="HGS school Faridabad "
          isOpen={openMain === 1}
          onClick={() => toggleMain(1)}
        >
          <div className="space-y-2">
            <SubAccordionItem
              title="Earth Day 2025"
              parent="Faridabad"
              imageCount="15"
              content="Content for Sub Accordion 1"
              isOpen={openSub[1] === 1}
              onClick={() => toggleSub(1, 1)}
            />
            {/* <SubAccordionItem
              title="Sub Accordion 2"
              content="Content for Sub Accordion 2"
              isOpen={openSub[1] === 2}
              onClick={() => toggleSub(1, 2)}
            /> */}
          </div>
        </AccordionItem>

        {/* Main Accordion 2 
        <AccordionItem
          title="Main Accordion 2"
          isOpen={openMain === 2}
          onClick={() => toggleMain(2)}
        >
          <div className="space-y-2">
            <SubAccordionItem
              title="Sub Accordion 1"
              content="Content for Sub Accordion 1 under Main Accordion 2"
              isOpen={openSub[2] === 1}
              onClick={() => toggleSub(2, 1)}
            />
          </div>
        </AccordionItem>
        */}
      </div>
    </div>
  );
  }

}

export default Gallery;